import {createContext} from 'react';

import {type DisplayedFinancialProductQuote} from 'features/financial-products';

import {
  FinancialProductPreferenceCoordinates,
  FinancialProductType,
} from '../../api/types/onlineOfferTypes';
import {type useFinancialProductPreference} from './useFinancialProductPreference';

export type FinancialProductPreferenceContextValue = ReturnType<
  typeof useFinancialProductPreference
> & {
  /** The coordinates the opened product's result describes: a drag preview, else the opened ones. */
  displayedCoordinates: FinancialProductPreferenceCoordinates | null;
  /** Shows a slider position that has not been released; nothing is written. */
  preview: (coordinates: FinancialProductPreferenceCoordinates) => void;
  /** The result a product shows now: the stored quote, a local quote, or none. */
  getDisplayed: (productType: FinancialProductType) => DisplayedFinancialProductQuote;
};

/** One customer choice shared by the financing section and the price card. */
export const FinancialProductPreferenceContext =
  createContext<FinancialProductPreferenceContextValue | null>(null);
